import { Link } from 'react-router-dom';
import { Mail, ArrowRight } from 'lucide-react';
import { useAuthStore } from '@/stores/auth.store';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

export default function VerifyEmailPendingPage() {
  const email = useAuthStore((s) => s.user?.email);

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-bg-secondary p-6 relative overflow-hidden">
      <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] rounded-full bg-primary/10 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] rounded-full bg-accent/5 blur-[120px] pointer-events-none" />

      <div className="w-full max-w-md z-10 space-y-6">
        <div className="text-center">
          <span className="text-3xl font-extrabold tracking-tight text-primary">Cutlyft</span>
        </div>

        <Card className="border border-border/50 shadow-xl bg-bg-elevated/80 backdrop-blur-md">
          <CardHeader className="text-center pb-2">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary mb-4">
              <Mail className="h-8 w-8" />
            </div>
            <CardTitle className="text-2xl text-fg-primary">Check your inbox</CardTitle>
            <CardDescription className="text-fg-secondary pt-1">
              We've sent a verification link to
            </CardDescription>
          </CardHeader>

          <CardContent className="text-center space-y-6">
            {email && (
              <p className="text-fg-primary font-semibold text-base break-all">{email}</p>
            )}
            <p className="text-sm text-fg-muted">
              Click the link in the email to verify your address. The link expires in 24 hours.
            </p>
            <p className="text-xs text-fg-muted">
              Can't find it? Check your spam or junk folder.
            </p>
          </CardContent>

          <CardFooter className="flex flex-col gap-3 border-t border-border/30 pt-6">
            <Button
              asChild
              className="w-full bg-primary hover:bg-primary/95 text-primary-foreground font-semibold h-11"
            >
              <Link to="/dashboard">
                Continue to Dashboard
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <p className="text-xs text-center text-fg-muted">
              You can verify later from your profile settings.
            </p>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
